import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import {
  COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_BEGIN,
  COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_SUCCESS,
  COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_FAILURE,
  COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_DISMISS_ERROR,
} from './constants';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function deleteRowLevelSecurityFilter(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_BEGIN,
    });
    const { projectId, collectionUuid, rlsFilterId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/security/row-level-security-filter/${collectionUuid}/collection/${rlsFilterId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Deleted collection row level security filter');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection row level security filter');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection filter');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteRowLevelSecurityFilterError() {
  return {
    type: COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_BEGIN:
      return {
        ...state,
        deleteRowLevelSecurityFilterPending: true,
        deleteRowLevelSecurityFilterError: null,
      };

    case COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index].finders = action.data;
      return {
        ...state,
        deleteRowLevelSecurityFilterPending: false,
        deleteRowLevelSecurityFilterError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          rowLevelSecurityFilter: action.data,
        },
      };

    case COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_FAILURE:
      return {
        ...state,
        deleteRowLevelSecurityFilterPending: false,
        deleteRowLevelSecurityFilterError: action.data.error,
      };

    case COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_DISMISS_ERROR:
      return {
        ...state,
        deleteRowLevelSecurityFilterError: null,
      };

    default:
      return state;
  }
}
